import { render, staticRenderFns } from "./ChoosePackage.vue?vue&type=template&id=ef02aaf0&scoped=true&"
import script from "./ChoosePackage.vue?vue&type=script&lang=js&"
export * from "./ChoosePackage.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePackage.vue?vue&type=style&index=0&id=ef02aaf0&scoped=true&lang=scss&"
import style1 from "./ChoosePackage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef02aaf0",
  null
  
)

export default component.exports